var render = function () {
  var _vm$work, _vm$work$imgs, _vm$work$imgs$, _vm$work2, _vm$work3, _vm$work3$author, _vm$work3$author$name, _vm$work4, _vm$work5, _vm$work6, _vm$work7, _vm$work8, _vm$work8$price_estim, _vm$work8$price_estim2, _vm$work8$price_estim3, _vm$work9, _vm$work9$price_estim, _vm$work9$price_estim2, _vm$work9$price_estim3, _vm$work10, _vm$work10$price_auct, _vm$work10$price_auct2, _vm$work10$price_auct3, _vm$work11, _vm$work11$price_auct, _vm$work11$price_auct2, _vm$work11$price_auct3, _vm$work12, _vm$work13, _vm$work13$price_sale, _vm$work13$price_sale2;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('router-link', {
    staticClass: "gallery-card",
    attrs: {
      "to": "/auction-works/".concat(_vm.work._id)
    }
  }, [_c('div', {
    staticClass: "gallery-card__img-wrap"
  }, [_c('v-img', {
    staticClass: "grey-ef",
    attrs: {
      "contain": "",
      "aspect-ratio": 1 / 1,
      "src": (_vm$work = _vm.work) === null || _vm$work === void 0 ? void 0 : (_vm$work$imgs = _vm$work.imgs) === null || _vm$work$imgs === void 0 ? void 0 : (_vm$work$imgs$ = _vm$work$imgs[0]) === null || _vm$work$imgs$ === void 0 ? void 0 : _vm$work$imgs$.url,
      "eager": ""
    },
    on: {
      "load": function load($event) {
        return _vm.$emit('loaded');
      }
    }
  })], 1), _c('div', {
    staticClass: "gallery-card__con"
  }, [_c('div', {
    staticClass: "py-10 py-md-14"
  }, [_c('div', [_c('strong', {
    staticClass: "font-size-14 font-weight-medium"
  }, [_vm._v("LOT. " + _vm._s((_vm$work2 = _vm.work) === null || _vm$work2 === void 0 ? void 0 : _vm$work2.lot))])]), _c('div', {
    staticClass: "mt-8 mt-md-10 ellip"
  }, [_c('strong', {
    staticClass: "font-size-20 font-size-md-24 font-weight-medium font-notoserif"
  }, [_vm._v(_vm._s((_vm$work3 = _vm.work) === null || _vm$work3 === void 0 ? void 0 : (_vm$work3$author = _vm$work3.author) === null || _vm$work3$author === void 0 ? void 0 : (_vm$work3$author$name = _vm$work3$author.name) === null || _vm$work3$author$name === void 0 ? void 0 : _vm$work3$author$name.ko))])]), _c('div', {
    staticClass: "mt-md-2 ellip"
  }, [_c('span', {
    staticClass: "font-size-16 font-size-md-18 font-notoserif"
  }, [_vm._v(_vm._s((_vm$work4 = _vm.work) === null || _vm$work4 === void 0 ? void 0 : _vm$work4.subject))])]), _c('div', {
    staticClass: "mt-10 mt-md-12"
  }, [_c('span', {
    staticClass: "font-size-14 grey-68--text"
  }, [_vm._v(_vm._s((_vm$work5 = _vm.work) === null || _vm$work5 === void 0 ? void 0 : _vm$work5.year) + " ㅣ " + _vm._s((_vm$work6 = _vm.work) === null || _vm$work6 === void 0 ? void 0 : _vm$work6.material) + " ㅣ " + _vm._s((_vm$work7 = _vm.work) === null || _vm$work7 === void 0 ? void 0 : _vm$work7.dimensionTag))])])]), _vm.isProgram ? [_c('v-divider', {
    staticClass: "grey-da"
  }), _c('div', {
    staticClass: "font-size-14 py-10 py-md-16"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": "",
      "align": "baseline"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('span', [_vm._v("추정가")])]), _c('v-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('div', {
    staticClass: "grey-68--text pl-sm-12"
  }, [_vm._v("KRW " + _vm._s(((_vm$work8 = _vm.work) === null || _vm$work8 === void 0 ? void 0 : (_vm$work8$price_estim = _vm$work8.price_estimated) === null || _vm$work8$price_estim === void 0 ? void 0 : (_vm$work8$price_estim2 = _vm$work8$price_estim.from) === null || _vm$work8$price_estim2 === void 0 ? void 0 : (_vm$work8$price_estim3 = _vm$work8$price_estim2.format) === null || _vm$work8$price_estim3 === void 0 ? void 0 : _vm$work8$price_estim3.call(_vm$work8$price_estim2)) || "0") + " ~ " + _vm._s(((_vm$work9 = _vm.work) === null || _vm$work9 === void 0 ? void 0 : (_vm$work9$price_estim = _vm$work9.price_estimated) === null || _vm$work9$price_estim === void 0 ? void 0 : (_vm$work9$price_estim2 = _vm$work9$price_estim.to) === null || _vm$work9$price_estim2 === void 0 ? void 0 : (_vm$work9$price_estim3 = _vm$work9$price_estim2.format) === null || _vm$work9$price_estim3 === void 0 ? void 0 : _vm$work9$price_estim3.call(_vm$work9$price_estim2)) || ""))])])], 1), _c('v-row', {
    staticClass: "mt-2 mt-md-4",
    attrs: {
      "no-gutters": "",
      "align": "baseline"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('span', [_vm._v("시작가")])]), _c('v-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('div', {
    staticClass: "grey-68--text pl-sm-12"
  }, [_vm._v("KRW " + _vm._s(((_vm$work10 = _vm.work) === null || _vm$work10 === void 0 ? void 0 : (_vm$work10$price_auct = _vm$work10.price_auction) === null || _vm$work10$price_auct === void 0 ? void 0 : (_vm$work10$price_auct2 = _vm$work10$price_auct.from) === null || _vm$work10$price_auct2 === void 0 ? void 0 : (_vm$work10$price_auct3 = _vm$work10$price_auct2.format) === null || _vm$work10$price_auct3 === void 0 ? void 0 : _vm$work10$price_auct3.call(_vm$work10$price_auct2)) || "0"))])])], 1), !_vm.isOffline ? _c('v-row', {
    staticClass: "font-weight-bold red--text mt-2 mt-md-4",
    attrs: {
      "no-gutters": "",
      "align": "baseline"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('span', [_vm._v("현재가")])]), _c('v-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('div', {
    staticClass: "pl-sm-12"
  }, [_vm._v("KRW " + _vm._s(((_vm$work11 = _vm.work) === null || _vm$work11 === void 0 ? void 0 : (_vm$work11$price_auct = _vm$work11.price_auction) === null || _vm$work11$price_auct === void 0 ? void 0 : (_vm$work11$price_auct2 = _vm$work11$price_auct.current) === null || _vm$work11$price_auct2 === void 0 ? void 0 : (_vm$work11$price_auct3 = _vm$work11$price_auct2.format) === null || _vm$work11$price_auct3 === void 0 ? void 0 : _vm$work11$price_auct3.call(_vm$work11$price_auct2)) || "0"))])])], 1) : _vm._e()], 1), _c('v-divider', {
    staticClass: "grey-da"
  }), _c('div', {
    staticClass: "d-flex flex-wrap align-center justify-space-between py-6 py-md-8"
  }, [_c('auction-work-until', {
    staticClass: "font-size-14 grey-68--text",
    attrs: {
      "work": _vm.work
    }
  }), _c('auction-work-action', _vm._b({}, 'auction-work-action', {
    work: _vm.work
  }, false), [_c('v-btn', {
    attrs: {
      "slot": "on-going",
      "small": "",
      "color": "primary"
    },
    slot: "on-going"
  }, [_vm._v("응찰하기")]), _c('v-btn', {
    staticClass: "px-26",
    attrs: {
      "slot": "finished",
      "small": "",
      "color": "grey-c7",
      "dark": ""
    },
    slot: "finished"
  }, [_vm._v("마감")])], 1)], 1)] : _vm._e(), _vm.isPermanent && ((_vm$work12 = _vm.work) === null || _vm$work12 === void 0 ? void 0 : _vm$work12.price_sale) !== 0 ? [_c('v-divider', {
    staticClass: "grey-da"
  }), _c('div', {
    staticClass: "font-size-14 py-10 py-md-16"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": "",
      "align": "baseline"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('span', [_vm._v("판매가")])]), _c('v-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('div', {
    staticClass: "grey-68--text pl-sm-12"
  }, [_vm._v("KRW " + _vm._s(((_vm$work13 = _vm.work) === null || _vm$work13 === void 0 ? void 0 : (_vm$work13$price_sale = _vm$work13.price_sale) === null || _vm$work13$price_sale === void 0 ? void 0 : (_vm$work13$price_sale2 = _vm$work13$price_sale.format) === null || _vm$work13$price_sale2 === void 0 ? void 0 : _vm$work13$price_sale2.call(_vm$work13$price_sale)) || "0"))])])], 1)], 1)] : _vm._e(), _c('v-divider', {
    staticClass: "primary"
  })], 2)]);
}
var staticRenderFns = []

export { render, staticRenderFns }